export const background = {
  default: 'rgb(5, 7, 9)',
  subtle: 'rgb(14, 17, 19)',
}
export const surface = {
  default: 'rgb(14, 17, 19)',
  raised: 'rgb(34, 39, 43)',
  sunken: 'rgb(5, 7, 9)',
}
export const text = {
  default: 'rgb(245, 245, 245)',
  muted: 'rgb(205, 211, 214)',
  subtle: 'rgb(136, 143, 146)',
  inverse: 'rgb(5, 7, 9)',
  link: 'rgb(140, 224, 255)',
}
export const border = {
  default: 'rgb(53, 59, 63)',
  subtle: 'rgb(34, 39, 43)',
  strong: 'rgb(136, 143, 146)',
}
export const action = {
  default: 'rgb(38, 174, 255)',
  hover: 'rgb(140, 224, 255)',
  subtle: 'rgb(0, 16, 55)',
}
export const success = {
  surface: 'rgb(0, 22, 0)',
  text: 'rgb(143, 199, 138)',
  border: 'rgb(0, 90, 2)',
  solid: 'rgb(57, 153, 54)',
}
export const warning = {
  surface: 'rgb(39, 4, 0)',
  text: 'rgb(238, 168, 138)',
  border: 'rgb(136, 47, 3)',
  solid: 'rgb(211, 103, 52)',
}
export const danger = {
  surface: 'rgb(35, 0, 2)',
  text: 'rgb(234, 146, 148)',
  border: 'rgb(124, 6, 31)',
  solid: 'rgb(198, 63, 78)',
}
export const info = {
  surface: 'rgb(2, 7, 28)',
  text: 'rgb(128, 152, 194)',
  border: 'rgb(25, 51, 102)',
  solid: 'rgb(66, 100, 164)',
}
